import { React, useState,useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Container } from 'react-bootstrap';
import { InterventionTypeForm } from '../InterventionTypeForm/InterventionTypeForm';
import * as api from 'services/api';
import { useTranslation } from 'react-i18next';
export function EditInterventionType() {
    const { t } = useTranslation();
    const { id } = useParams();
    const [interventionTypeFormData, setInterventionTypeFormData] = useState({
        name: '',
        text: '',
        interventionId: 0,
        updatePhone: false,
        enable: false,
        mobileDevice: false,
        checkLocation: false,
        selectedPhone: 1,
        deletePhone: false,
        controlDigitsNumber: 0
    });
    const [error, setError] = useState('');
    const navigate = useNavigate();

    async function fetchData() {
        try {
            const response = await api.getInterventionType(id);
            if (response.status === 200) {
                const updatedInterventionType = {
                    ...response.data
                };
                setInterventionTypeFormData(updatedInterventionType);
            } else {
                setError(t('interventionTypeErrorFetchData'));
            }
        } catch (error) {
            setError(t('usErrorFetchUserData'));
        }
    }

    useEffect(() => {
        fetchData();
    }, [id]);

    const handleInputChange = (event) => {
        const { name, value } = event.target;
        setInterventionTypeFormData({
            ...interventionTypeFormData,
            [name]: value
        });
    };

    const handleSubmit = async () => {
        const response = await api.updateInterventionType(id, interventionTypeFormData);
        if (response.status === 200) {

            navigate('/interventionTypeManagement');      
        } else {
            setError(t('interventionTypeError'));
        }
    };
  
    return (
        <Container>
            <h2 className="mt-4">{t('it.Edit')}</h2>
            <InterventionTypeForm
                interventionTypeFormData={interventionTypeFormData}
                handleInputChange={handleInputChange}
                handleSubmit={handleSubmit}
                error={error}
                setError={setError}
                isEditing={true}
            />
        </Container>
    );
}